import { $t } from "../../../utils/intl";
import { handleTextField } from "../../prefill/helpers";
import { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { TextAreaFieldControl } from "./TextareaFieldControl/TextAreaFieldControl";
import { defaultToReviewString } from "../review/reviewString.helpers";

export type TextareaFieldValue = string;

export const textareaFieldConfig: FieldRegistryConfig<TextareaFieldValue> = {
  icon: "textarea",
  control: (props) => (
    <TextAreaFieldControl placeholder={$t(fieldsText.textPlaceholder)} {...props} />
  ),
  prefill: handleTextField,
  toReviewString: defaultToReviewString,
};
